import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Designs from './pages/Designs';
import Settings from './pages/Settings';
import Sidebar from './components/Sidebar'; // Adjust the path as necessary
import LoginPage from './pages/Login';
import SignupPage from './pages/SignUp';
import Welcome from './pages/Welcome';
import SavedPage from './pages/Saved';
import MockupsPage from './pages/MockupsPage';
import PublishPage from './pages/PublishPage';
import './App.css';
import { useState, useEffect } from 'react';


// Import Chip and Box components from MUI
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function App() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
   if (!isDesktop) {
     return <div>
      
       <Box sx={{marginTop:'100px', padding:'50px', borderRadius:'20px', marginLeft: '20px', marginRight:'20px', backgroundColor: '#F5F5F5' }}>
       <Typography variant='h5'>Use this app on your desktop, mobile version coming soon...</Typography>
       </Box>
      
       </div>;
   }
  return (
    <Router>
      <Box sx={{ position: 'fixed', right: 50, top: 50, zIndex: 'tooltip' }}>
        <Chip label="Beta v1.1" sx={{ fontWeight: 'bold', fontSize: '1rem', height: '50px', borderRadius: '24px', padding:'20px' }} />
      </Box>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation();

  return (
    <div style={{ display: 'flex' }}>
      {!["/", "/signup", "/welcome"].includes(location.pathname) && <Sidebar />}
      <div style={{ flex: 1, padding: '50px' }}>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/designs" element={<Designs />} />
          <Route path="/home" element={<Home />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/saved" element={<SavedPage />} />
          <Route path="/mockups" element={<MockupsPage />} />
          <Route path="/publish" element={<PublishPage />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
